import './TrackmanParameters.scss';
import { useTranslation } from 'react-i18next';
import useSetPageTitle from 'utilities/useSetPageTitle';
import { useTrackmanParametersNavigation } from './useTrackmanParametersNavigation';
import CategoriesTabs from './components/CategoriesTabs/CategoriesTabs';
import SubcategoryTabs from './components/SubcategoryTabs/SubcategoryTabs';
import ParameterList from './components/ParameterList/ParameterList';
import ParameterDisplay from './components/ParameterDisplay/ParameterDisplay';

export const TrackmanParameters = () => {
  const { t } = useTranslation();

  useSetPageTitle({
    title: t('TrackmanParameters', { ns: 'trackmanParameters' }),
  });

  const {
    categories,
    selectedCategory,
    selectCategory,
    subcategories,
    selectedSubcategory,
    selectSubcategory,
    parametersInSelectedSubcategory,
    selectedParameter,
    selectParameter,
  } = useTrackmanParametersNavigation();

  return (
    <>
      <div className='default-page-header'>
        <h1 className='page-title'>{t('TrackmanParameters', { ns: 'trackmanParameters' })}</h1>
        <span className='page-subtitle'>{t('CheckOutTheDefinitions', { ns: 'learningMaterials' })}</span>
      </div>
      <CategoriesTabs categories={categories} selectedCategoryId={selectedCategory?.id} onCategorySelected={selectCategory} />
      {categories.length > 0 && (
        <div className='trackman-parameters-wrapper'>
          <ParameterDisplay parameter={selectedParameter} />
          <div className='categories-and-parameters-container'>
            <SubcategoryTabs
              subcategories={subcategories}
              selectedSubcategoryId={selectedSubcategory?.id}
              onSubcategorySelected={selectSubcategory}
            />
            <ParameterList
              parameters={parametersInSelectedSubcategory}
              selectedParameterId={selectedParameter?.id}
              onParameterSelected={selectParameter}
            />
          </div>
        </div>
      )}
    </>
  );
};
